<template>
  <div class="container-fluid content" v-if="team">
    <!-- Header mit Kontostand -->
    <balance-header :transient-balance-adjustment="-transientInvest"/>
    <sakali-header :title="team.name" class="mt-4 pt-2 mb-3">
      <template v-slot:icon>
        <team-emblem v-if="user.team" class="ms-1" :emblem-id="user.team.emblemId" size="57"/>
      </template>
      <template v-slot:super-title>
        <div>
          <sakali-user :user="user" :show-team="false"></sakali-user>
        </div>
      </template>
    </sakali-header>
    <div class="mt-2 text-center">Einstellungen für das nächste Spiel</div>
    <team-management vue-if="team"
                     :team="team"
                     @update:team="loadTeam"
                     @update:transientInvest="this.transientInvest = $event"/>
  </div>
</template>

<script>
import sakaliApi from '../sakali-api'
import BalanceHeader from "../components/BalanceFixedTopWidget";
import TeamManagement from "../components/team/TeamManagement";
import {mapGetters, mapActions} from 'vuex'
import 'vue-slider-component/theme/antd.css'

export default {
  data() {
    return {
      team: null,
      transientInvest: 0
    }
  },
  computed: {
    ...mapGetters(['loggedIn', 'user']),
  },
  methods: {
    ...mapActions(['handleErrorAction']),
    loadTeam() {
      if (this.loggedIn) {
        sakaliApi.get('/teams/bycoach/' + this.user.id).then(response => {
          this.team = response.data;
        }).catch(error => {
          this.handleErrorAction(error)
        })
      }
    }
  },
  mounted() {
    this.loadTeam()
  },
  components: {
    BalanceHeader,
    TeamManagement
  }
}
</script>
